
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-notice",
      function () {
        return require("private-next-pages/privacy-notice.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-notice"])
      });
    }
  